import React from 'react';
import Svg, { Path } from 'react-native-svg';
import theme from '@/constants/colors';

// Badge icons from figma/icons/*.svg, used verbatim (12x12 viewBox).
// Fill colour comes from the theme so badges can tint per state.

export function DistanceIcon({ size = 12, color }: { size?: number; color: string }) {
  // Exact paths from figma/icons/Group 2475.svg (12x12)
  return (
    <Svg width={size} height={size} viewBox="0 0 12 12">
      <Path
        d="M0 9.59726C0 8.27178 1.07451 7.19727 2.39999 7.19727C3.72547 7.19727 4.79999 8.27178 4.79999 9.59726C4.79999 10.9227 3.72547 11.9973 2.39999 11.9973C1.07451 11.9973 0 10.9227 0 9.59726Z"
        fill={color}
      />
      <Path
        d="M7.19702 2.39999C7.19702 1.07451 8.27154 0 9.59701 0C10.9225 0 11.997 1.07451 11.997 2.39999C11.997 3.72547 10.9225 4.79999 9.59701 4.79999C8.27154 4.79999 7.19702 3.72547 7.19702 2.39999Z"
        fill={color}
      />
      <Path
        d="M2.40861 7.78983L3.0086 7.8074C3.0027 8.02192 3.00274 8.22037 3.00274 8.40272H1.80275C1.80275 8.22144 1.80217 8.00687 1.80861 7.77342L2.40861 7.78983ZM3.39298 5.60429C3.25759 5.95114 3.16774 6.31059 3.10938 6.666L2.51759 6.56874L1.92579 6.47264C1.99466 6.05308 2.10295 5.60922 2.27501 5.16835L3.39298 5.60429ZM4.30235 3.46445L4.65274 3.95195C4.34899 4.17047 4.10329 4.41692 3.90391 4.67968L3.42696 4.3164L2.94884 3.95429C3.21801 3.59955 3.54818 3.26862 3.95196 2.97812L4.30235 3.46445ZM6.66953 3.14804C6.26555 3.22348 5.90987 3.32536 5.59727 3.44687L5.38047 2.88789L5.1625 2.3289C5.55034 2.17814 5.97829 2.05708 6.44922 1.96914L6.66953 3.14804ZM8.39335 3.00273C8.19087 3.00273 7.99541 3.00826 7.80859 3.01797L7.77812 2.41797L7.74648 1.81914C7.95491 1.80831 8.17099 1.80273 8.39335 1.80273V3.00273Z"
        fill={color}
        stroke={color}
        strokeWidth={0.2}
        strokeLinejoin="bevel"
      />
    </Svg>
  );
}

export function FilterIcon({ size = 18, color }: { size?: number; color: string }) {
  // figma/icons/Group.svg — slider-knob filter icon (16x12). Knob fill is the
  // dark button background per the design (#272F0A on the filter button).
  return (
    <Svg width={size} height={(size * 12) / 16} viewBox="0 0 16 12">
      <Path
        d="M0.899902 2.34766H14.8966M0.899902 9.34769H14.8966"
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <Path
        d="M5.27448 11.0967C6.24075 11.0967 7.02407 10.3132 7.02407 9.34669C7.02407 8.38019 6.24075 7.59668 5.27448 7.59668C4.30822 7.59668 3.5249 8.38019 3.5249 9.34669C3.5249 10.3132 4.30822 11.0967 5.27448 11.0967Z"
        fill={theme.backgroundSecondary}
        stroke={color}
        strokeWidth={1.2}
        strokeLinejoin="bevel"
      />
      <Path
        d="M10.5247 4.09963C11.491 4.09963 12.2743 3.31612 12.2743 2.34962C12.2743 1.38312 11.491 0.599609 10.5247 0.599609C9.55846 0.599609 8.77515 1.38312 8.77515 2.34962C8.77515 3.31612 9.55846 4.09963 10.5247 4.09963Z"
        fill={theme.backgroundSecondary}
        stroke={color}
        strokeWidth={1.2}
      />
    </Svg>
  );
}

export function TerrainIcon({ size = 12, color }: { size?: number; color: string }) {
  // figma/icons/Vector 1071.svg — jagged mountain-range glyph (difficulty badge)
  return (
    <Svg width={size} height={size} viewBox="0 0 12 12">
      <Path
        d="M2.51736 7.92852L0.422119 11.2285H11.4221V0.228516L7.75545 7.37852L6.18402 4.62852L3.56498 10.1285L2.51736 7.92852Z"
        fill={color}
        stroke={color}
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
    </Svg>
  );
}

export function RatingStarIcon({ size = 12, color }: { size?: number; color: string }) {
  // figma/icons/Star 7.svg
  return (
    <Svg width={size} height={size} viewBox="0 0 12 12">
      <Path
        d="M5.86255 0.21875L7.59613 3.79053L11.3625 4.42038L8.66755 7.2577L9.26174 11.2188L5.86255 9.40053L2.46336 11.2188L3.05755 7.2577L0.362549 4.42038L4.12896 3.79053L5.86255 0.21875Z"
        fill={color}
        stroke={color}
        strokeLinejoin="bevel"
      />
    </Svg>
  );
}